import { useState } from "react";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useMST4060_R01Store } from "./Store_MST4060_R01";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";

// 조회월·상태·부품유형 검색조건을 입력하는 영역을 렌더링한다.
export const SearchSection_MST4060_R01 = () => {

	// 공통코드 옵션과 현재 조회조건을 연결해 검색 필터를 구성한다.
	// 부품유형은 SPARES_TYPE 공통코드(기계/전기/제어/구동/공압/유압/센서/소모성/안전)를 사용한다.
	const { eqmStatusList, sparesTypeList } = useCommonCodeStore();
	const { MST4060_R01Filter, setMST4060_R01Filter } = useMST4060_R01Store();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

	return (
		<SearchSectionForm>
			<SearchMonthSingleForm
				label="등록일자"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={new Date(`${MST4060_R01Filter.searchYm}-01`)}
				onChange={(date) => date && setMST4060_R01Filter({
					searchYm: `${formatDateYear4(date)}-${formatDateMonth(date)}`
				})}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label="상태"
				value={MST4060_R01Filter.eqmStatus || ''}
				onChangeItem={(item) => setMST4060_R01Filter({ eqmStatus: item?.minorCd || '' })}
				optionList={eqmStatusList}
			/>
			<SearchDropDownForm
				label="부품유형"
				value={MST4060_R01Filter.equipmentType || ''}
				onChangeItem={(item) => setMST4060_R01Filter({ equipmentType: item?.minorCd || '' })}
				optionList={sparesTypeList}
			/>
		</SearchSectionForm>
	);
};
